export const thirtyMinutes = 30 * 60 * 1000;
export const oneHour = 60 * 60 * 1000;
